// Normaliza a minúsculas sin tildes ni símbolos: lo que admite el campo `usuario`.
const limpiar = (texto) =>
  texto.normalize('NFD').replace(/[̀-ͯ]/g, '').toLowerCase().replace(/[^a-z0-9]/g, '');

// Propone un usuario a partir del nombre del jugador: «primer.último»
// («ANA PÉREZ GARCÍA» -> ana.garcia; «JUAN REALE (COSLADA)» -> juan.reale).
// Si ya está cogido, añade un número (ana.garcia2). `existentes` = usuarios actuales.
export function proponerUsuario(nombre, existentes = []) {
  const palabras = nombre.replace(/\([^)]*\)/g, ' ').split(/\s+/).map(limpiar).filter(Boolean);
  if (palabras.length === 0) return '';
  const base = palabras.length === 1 ? palabras[0] : `${palabras[0]}.${palabras[palabras.length - 1]}`;
  const usados = new Set(existentes.map((u) => u.toLowerCase()));
  let candidato = base;
  for (let n = 2; usados.has(candidato); n += 1) candidato = `${base}${n}`;
  return candidato;
}
